import { FieldValues } from 'react-hook-form'

import { CellFormGroup } from 'Shared/molecules/Form'

import { CellEditType } from 'Core/interfaces/Form'

import { Props } from './types'

const CellFormItem = <
	SelectFieldNames extends string,
	InputFieldNames extends string,
	DatePickerFieldNames extends string,
	TFieldValues extends FieldValues
>(
	props: Props<SelectFieldNames, InputFieldNames, DatePickerFieldNames, TFieldValues>
) => {
	const {
		type,
		isOptionsLoading = false,
		currentOptions,
		config,
		dataIndex,
		control,
		save
	} = props
	switch (type) {
		case CellEditType.select:
			const selectConfig = config.selects[dataIndex as SelectFieldNames]
			return (
				<CellFormGroup.Select
					control={control}
					loading={isOptionsLoading}
					{...selectConfig.props}
					{...(currentOptions ? { options: currentOptions } : {})}
				/>
			)
		case CellEditType.input:
			const inputConfig = config.inputs[dataIndex as InputFieldNames]
			return (
				<CellFormGroup.Input control={control} onPressEnter={save} {...inputConfig.props} />
			)
		case CellEditType.date:
			const datePickerConfig = config.datePickers[dataIndex as DatePickerFieldNames]
			return <CellFormGroup.DatePicker control={control} {...datePickerConfig.props} />
	}
	return <></>
}

export default CellFormItem
